// @flow

export default (parts: any[], delimiter?: string = ", ") => parts.filter((r) => !!r) // filter empty results
	.join(delimiter);
